import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Chapters } from "@/components/landing/Chapters";
import { Modalities } from "@/components/landing/Modalities";
import { Capsule } from "@/components/landing/Capsule";
import { Trust } from "@/components/landing/Trust";
import { Location } from "@/components/landing/Location";
import { Reviews } from "@/components/landing/Reviews";
import { FAQ } from "@/components/landing/FAQ";
import { Offer } from "@/components/landing/Offer";
import { Footer } from "@/components/landing/Footer";
import { StickyCTA } from "@/components/landing/StickyCTA";
import AdminLeads from "@/pages/AdminLeads";

const Landing = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="noise-overlay min-h-screen bg-rest-base text-white" data-testid="landing-page">
      <Nav />
      <main>
        <Hero />
        <Modalities />
        <Marquee />
        <Chapters />
        <Capsule />
        <Trust />
        <Location />
        <Reviews />
        <Offer />
        <FAQ />
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<AdminLeads />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
